module.exports = __webpack_public_path__ + "static/tooltip-punctuation-do-2add554733b0a0743470443239f65c1b.png";